export function getByMap(a,b,c){return c?c:a[b]}
//# sourceMappingURL=getByMap.js.map